const listingSpaceMetadata = listing => {
  const amenitiesSpaceMetadata = () => ({
    breakOutSpace: listing.breakOutSpace?.value || '',
    breakOutSpaceDataSource: listing.breakOutSpace?.dataSource,
    furnished: listing.furnished.value || '',
    furnishedDataSource: listing.furnished.dataSource,
    passengerElevatorCount: listing.passengerElevatorCount.value || '',
    passengerElevatorCountDataSource: listing.passengerElevatorCount.dataSource,
    phoneBooths: listing.phoneBooths?.value || '',
    phoneBoothsDataSource: listing.phoneBooths?.dataSource,
    privateOutdoorSpace: listing.privateOutdoorSpace.value || '',
    privateOutdoorSpaceDataSource: listing.privateOutdoorSpace.dataSource,
    serviceElevatorCount: listing.serviceElevatorCount.value || '',
    serviceElevatorCountDataSource: listing.serviceElevatorCount.dataSource,
    sharedPantry: listing.sharedPantry.value || '',
    sharedPantryDataSource: listing.sharedPantry.dataSource,
  });

  const dataCollectionSpaceMetadata = () => ({
    buildOutLevel: listing.buildOutLevel.value || '',
    buildOutLevelDataSource: listing.buildOutLevel.dataSource,
    ceilingType: listing.ceilingType?.value || '',
    ceilingTypeDataSource: listing.ceilingType?.dataSource || '',
    coreFactorMultiTenantFloor: listing.coreFactorMultiTenantFloor?.value,
    coreFactorMultiTenantFloorDataSource: listing.coreFactorMultiTenantFloor?.dataSource,
    coreFactorSingleTenantFloor: listing.coreFactorSingleTenantFloor?.value,
    coreFactorSingleTenantFloorDataSource: listing.coreFactorSingleTenantFloor?.dataSource,
    currentFfe: listing.currentFfe?.value || '',
    currentFfeDataSource: listing.currentFfe?.dataSource,
    currentSpaceCondition: listing.currentSpaceCondition?.value || '',
    currentSpaceConditionDataSource: listing.currentSpaceCondition?.dataSource || '',
    drinkingFountainCount: listing.drinkingFountainCount.value || '',
    drinkingFountainCountDataSource: listing.drinkingFountainCount.dataSource,
    electricalRoom: listing.electricalRoom.value || '',
    electricalRoomDataSource: listing.electricalRoom.dataSource,
    elevatorLocation: listing.elevatorLocation.value || '',
    elevatorLocationDataSource: listing.elevatorLocation.dataSource,
    exposedColumns: listing.exposedColumns?.value || '',
    exposedColumnsDataSource: listing.exposedColumns?.dataSource,
    exposureEast: listing.exposureEast?.value || '',
    exposureEastDataSource: listing.exposureEast?.dataSource,
    exposureNorth: listing.exposureNorth?.value || '',
    exposureNorthDataSource: listing.exposureNorth?.dataSource,
    exposureSouth: listing.exposureSouth?.value || '',
    exposureSouthDataSource: listing.exposureSouth?.dataSource,
    exposureWest: listing.exposureWest?.value || '',
    exposureWestDataSource: listing.exposureWest?.dataSource,
    exteriorSignage: listing.exteriorSignage.value || '',
    exteriorSignageDataSource: listing.exteriorSignage.dataSource,
    floorType: listing.floorType?.value || '',
    floorTypeDataSource: listing.floorType?.dataSource || '',
    gym: listing.gym?.value || '',
    gymDataSource: listing.gym?.dataSource,
    heatType: listing.heatType?.value || '',
    heatTypeDataSource: listing.heatType?.dataSource || '',
    interiorSignage: listing.interiorSignage.value || '',
    interiorSignageDataSource: listing.interiorSignage.dataSource,
    keyCardSpaceEntry: listing.keyCardSpaceEntry.value || '',
    keyCardSpaceEntryDataSource: listing.keyCardSpaceEntry.dataSource,
    mainPantryKitchen: listing.mainPantryKitchen?.value || '',
    mainPantryKitchenDataSource: listing.mainPantryKitchen?.dataSource,
    mechanicalRoom: listing.mechanicalRoom.value || '',
    mechanicalRoomDataSource: listing.mechanicalRoom.dataSource,
    officeFronts: listing.officeFronts?.value || '',
    officeFrontsDataSource: listing.officeFronts?.dataSource || '',
    officeLayout: listing.officeLayout?.value || '',
    officeLayoutDataSource: listing.officeLayout?.dataSource || '',
    privateBathroomsShower: listing.privateBathroomsShower?.value || '',
    privateBathroomsShowerDataSource: listing.privateBathroomsShower?.dataSource,
    receptionCeilingType: listing.receptionCeilingType?.value || '',
    receptionCeilingTypeDataSource: listing.receptionCeilingType?.dataSource || '',
    receptionFloorType: listing.receptionFloorType?.value || '',
    receptionFloorTypeDataSource: listing.receptionFloorType?.dataSource || '',
    serverRoom: listing.serverRoom?.value || '',
    serverRoomDataSource: listing.serverRoom?.dataSource || '',
    serviceType: listing.serviceType?.value || '',
    serviceTypeDataSource: listing.serviceType?.dataSource || '',
    sharedFloorBathroomStallCount: listing.sharedFloorBathroomStallCount.value || '',
    sharedFloorBathroomStallCountDataSource: listing.sharedFloorBathroomStallCount.dataSource,
    usableSquareFeet: listing.usableSquareFeet?.value,
    usableSquareFeetDataSource: listing.usableSquareFeet?.dataSource,
    viewLandmarkDetail: listing.viewLandmarkDetail?.value || '',
    viewLandmarkDetailDataSource: listing.viewLandmarkDetail?.dataSource,
    windowSidesCount: listing.windowSidesCount.value || '',
    windowSidesCountDataSource: listing.windowSidesCount.dataSource,
    windowViewEast: listing.windowViewEast?.value || '',
    windowViewEastDataSource: listing.windowViewEast?.dataSource || '',
    windowViewNorth: listing.windowViewNorth?.value || '',
    windowViewNorthDataSource: listing.windowViewNorth?.dataSource || '',
    windowViewSouth: listing.windowViewSouth?.value || '',
    windowViewSouthDataSource: listing.windowViewSouth?.dataSource || '',
    windowViewWest: listing.windowViewWest?.value || '',
    windowViewWestDataSource: listing.windowViewWest?.dataSource || '',
    windowViews: listing.windowViews?.value || [],
    windowViewsDataSource: listing.windowViews?.dataSource || '',
  });

  return {
    ...dataCollectionSpaceMetadata(),
    ...amenitiesSpaceMetadata(),
  };
};

export default listingSpaceMetadata;
